import React from 'react'
import * as Dropdown from 'component/base/Form/Dropdown'

export const FurikomiTesuryoFutanKbn = props => {
  return <Dropdown.Static kubunKey='furikomi_tesuryo_futan_kbn' {...props} />
}
